import React from "react";
import ForwardIcon from "../../../UI/IconComponents/ForwardIcon";
import Wrapper from "../../../UI/Wrapper/Wrapper";
import hero from "../../JazzysBurger/TopSection/images/hero.png";
import "./_Main.scss";

const GITHUB_URL = "https://github.com/Awa-Digital/orderforge";

const TopSection = () => {
  return (
    <div className="caseStudy__orderforge-top-section">
      <div className="hero-container">
        <img src={hero} alt="Commerce platform" />
      </div>
      <Wrapper className="orderforge-top-section__lower">
        <div>
          <span>
            <h6>Platform</h6>
            <p>
              Awa Digital&apos;s in-house commerce stack: shared services for
              accounts, catalogues, orders, payments, inventory, and admin.
              The same core is configured for each product we operate rather
              than rebuilt per client.
            </p>
          </span>
          <span>
            <h6>Open source</h6>
            <p>
              The repository is public at{" "}
              <a href={GITHUB_URL} target="_blank" rel="noreferrer">
                github.com/Awa-Digital/orderforge
              </a>
              .
            </p>
          </span>
          <div style={{ margin: 0, width: "100%", position: "relative" }}>
            <a
              className="orderforge-top-section__lower-launch-btn"
              href={GITHUB_URL}
              target="_blank"
              rel="noreferrer"
            >
              <p>GitHub</p>
              <ForwardIcon size={35} hoverColor={"rgb(0, 186, 128)"} />
            </a>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default TopSection;
